import React, { useEffect, useState } from 'react';
import cls from './tabbar.module.scss';
import {
  CashBackBronzeIcon,
  CashInIcon,
  CashOutIcon,
  LockIcon,
  LoginHistoryIcon,
  PromoIcon,
  SafeIcon,
  TicketHistoryIcon,
  TransactionHistoryIcon,
  PGamesIcon
} from '../../../assets/icons/menu';
import { BellIcon, CashbackHeaderIcon } from '../../../assets/icons';
import { Icon } from 'lb-components';
import { UserIcon, InfoIconFill } from '../../../assets/icons';
import {
  Badge,
  Button,
  Form,
  OverlayTrigger,
  Popover,
  ProgressBar,
} from 'react-bootstrap';
import { Api, Toast, useTranslation } from 'lb-store';
import { UseNavigation, UseOTP, UseUser } from 'lb-store/src/hooks';
import classes from '../../Header/Header.module.scss';

const TabBar = ({ onSelectMenu, setRoute }) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [enable2fa, setEnable2fa] = useState('off');
  const [enableSmsNotify, setEnableSmsNotify] = useState('off');
  const [cashbackData, setCashbackData] = useState({
    value: '0.00',
    percent: '0',
    level: '1',
  });
  const otp = UseOTP();
  const { User } = UseUser();

  useEffect(() => {
    Api.User.Info().then((res) => {
      if (res.status && res.data?.status === 1) {
        setCashbackData({
          value: res.data.op['cashback-value'],
          percent: res.data.op['cashback-percent'],
          level: res.data.op['cashback-level'],
        });
        setEnable2fa(res.data.op.sms);
        setEnableSmsNotify(res.data.op['sms_notify']);
      }
    });
  }, [User.isLogged]);

  const item = ({ key, icon, title }) => {
    return (
      <div
        className={cls.item}
        onClick={() => {
          onSelectMenu(key);
        }}
      >
        <Icon Icon={icon} width={'3.4rem'} height={'3.4rem'} />
        <span>{title}</span>
      </div>
    );
  };

  const smsAuthChange = (e) => {
    e.preventDefault();
    e.stopPropagation();

    Api.User.SetSms({ value: enable2fa }).then((res) => {
      //TODO: check status
      otp.open({
        onSuccess: (code, callback, close) => {
          Api.User.SetSms({
            value: enable2fa === 'on' ? 'off' : 'on',
            smsCode: code,
          }).then((res) => {
            if (res.status && res.data?.status === 1) {
              close();
              Toast.show({
                content: t('პარამეტრები წარმატებით შეიცვალა'),
              });
              setEnable2fa(enable2fa === 'on' ? 'off' : 'on');
            } else {
              //callback(res.data?.error);
              callback(t('შეცდომა! შეიყვანეთ სწორი SMS კოდი'));
            }
          });
        },
        onResend: (callback) => {
          Api.User.SetSms({ value: enable2fa }).then((res) => {
            callback(res.data?.left, res.data?.desc);
          });
        },
      });
    });
  };
  const smsNotifyChange = (e) => {
    e.preventDefault();
    e.stopPropagation();

    Api.User.SetSmsNotify({ value: enableSmsNotify }).then((res) => {
      //TODO: check status
      otp.open({
        onSuccess: (code, callback, close) => {
          Api.User.SetSmsNotify({
            value: enableSmsNotify === 'on' ? 'off' : 'on',
            smsCode: code,
          }).then((res) => {
            if (res.status && res.data?.status === 1) {
              close();
              Toast.show({
                content: t('პარამეტრები წარმატებით შეიცვალა'),
              });
              setEnableSmsNotify(enableSmsNotify === 'on' ? 'off' : 'on');
            } else {
              //callback(res.data?.error);
              callback(t('შეცდომა! შეიყვანეთ სწორი SMS კოდი'));
            }
          });
        },
        onResend: (callback) => {
          Api.User.SetSmsNotify({
            value: enableSmsNotify,
          }).then((res) => {
            callback(res.data?.left, res.data?.desc);
          });
        },
      });
    });
  };

  return (
    <div className={cls.tab}>
      <div className={cls.tabBar}>
        <div
          className={cls.tab}
          onClick={() => setIndex(0)}
          style={{ width: '30%' }}
        >
          {t('ბალანსი')}
        </div>
        <div
          className={cls.tab}
          onClick={() => setIndex(1)}
          style={{ width: '30%' }}
        >
          <span>{t('ისტორია')}</span>
        </div>
        <div
          className={cls.tab}
          onClick={() => setIndex(2)}
          style={{ width: '40%' }}
        >
          <span>{t('უსაფრთხოება')}</span>
        </div>
        <div
          className={cls.borderBottomActive}
          style={{
            left: `calc(30% * ${index})`,
            width: `${index === 2 ? '40%' : '30%'}`,
          }}
        />
      </div>
      <div className={cls.tabContent}>
        {index === 0 && (
          <>
            {item({
              key: 'deposit',
              icon: CashInIcon,
              title: t('ბალანსის შევსება'),
            })}
            {item({
              key: 'withdraw',
              icon: CashOutIcon,
              title: t('თანხის გატანა'),
            })}
            {item({
              key: 'promo-code',
              icon: PromoIcon,
              title: t('პრომო კოდის გააქტიურება'),
            })}
            {item({ key: 'safe', icon: SafeIcon, title: t('სეიფის მართვა') })}
            <div
              className={cls.item}
              onClick={() => onSelectMenu('notifications')}
            >
              <div className={cls.notifications}>
                <Icon Icon={BellIcon} width={'3.4rem'} height={'3.4rem'} />
                {User.notifications > 0 && (
                  <Badge bg={'danger'} className={cls.badge}>
                    {User.notifications}
                  </Badge>
                )}
              </div>
              <span>{t('შეტყობინებები')}</span>
            </div>
            <div className={cls.item} style={{ width: '100%' }}>
              <Icon
                Icon={CashbackHeaderIcon}
                style={{
                  height: '3.2rem',
                  width: '3.2rem',
                  backgroundSize: '3.2rem',
                  backgroundPosition: `0px -${
                    (parseInt(cashbackData?.level) - 1) * 3.2
                  }rem`,
                }}
                classname={classes.statusIcon}
              />
              <div className={cls.cashback}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <p className={cls.title}>{t('ქეშბექ სტატუსი')}</p>
                    <span className={cls.amount}>{cashbackData.value}</span>
                  </div>
                  <div>
                    <Button
                      variant={'secondary'}
                      className={cls.cashbackBtn}
                      onClick={() => setRoute('cashback')}
                    >
                      {' '}
                      {t('განაღდება')}
                    </Button>
                  </div>
                </div>
                <div className={cls.progress}>
                  <ProgressBar
                    variant='success'
                    now={parseInt(cashbackData.percent)}
                    animated={true}
                    style={{
                      borderRadius: '2rem',
                      backgroundColor: '#33353d',
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {index === 1 && (
          <>
            {item({
              key: 'ticket-history',
              icon: TicketHistoryIcon,
              title: t('ბილეთების ისტორია'),
            })}
            {item({
              key: 'transaction-history',
              icon: TransactionHistoryIcon,
              title: t('ტრანზაქციების ისტორია'),
            })}
            {item({
              key: 'auth-history',
              icon: LoginHistoryIcon,
              title: t('შემოსვლების ისტორია'),
            })}
          </>
        )}
        {index === 2 && (
          <>
            {item({
              key: 'personal-info',
              icon: UserIcon,
              title: t('პერსონალური ინფორმაცია'),
            })}
            {item({
              key: 'password-reset',
              icon: LockIcon,
              title: t('პაროლის შეცვლა'),
            })}
            {item({
              key: 'dis-account',
              icon: PGamesIcon,
              title: t('პასუხისმგებლიანი თამაში'),
            })}

            <div className={cls.itemTitle}>
              <span>{t('SMS სერვისი')}</span>
            </div>
            <div className={cls.smsService} style={{ width: '100%' }}>
              <div>
                <span>{t('ავტორიზაცია')}</span>
              </div>
              <div
                style={{ maxWidth: '50px' }}
                className={cls.info}
                onClick={(e) => e.stopPropagation()}
              >
                <Icon
                  style={{
                    height: '23px',
                    width: '23px',
                    backgroundColor: 'var(--bs-primary)',
                  }}
                  type={'vec'}
                  Icon={InfoIconFill}
                />
                <p>
                  <h3>{t('შენიშვნა')}</h3>
                  <span>
                    {t(
                      'ამ ფუნქციონალის გააქტიურება მოხდება სმსის ჩართვის შემდგომ'
                    )}
                  </span>
                </p>
              </div>
              <div
                style={{
                  maxWidth: '50px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <Form.Check
                  checked={enable2fa === 'on'}
                  onChange={smsAuthChange}
                  className={`custom-form-switch ${
                    enable2fa === 'on' ? 'active' : ''
                  }`}
                  size={'4x'}
                  type='switch'
                  id='custom-switch'
                />
              </div>
            </div>
            <div className={cls.smsService} style={{ width: '100%' }}>
              <div>
                <span>{t('SMS შეტყობინება')}</span>
              </div>
              <div
                style={{ maxWidth: '50px' }}
                className={cls.info}
                onClick={(e) => e.stopPropagation()}
              >
                {/*<Button variant='link'>
                  <FontAwesomeIcon icon={faInfoCircle} size={'2x'} />
                </Button>*/}
                <Icon
                  style={{
                    height: '23px',
                    width: '23px',
                    backgroundColor: 'var(--bs-primary)',
                  }}
                  type={'vec'}
                  Icon={InfoIconFill}
                />
                <p>
                  <h3>{t('შენიშვნა')}</h3>
                  <span>
                    {t(
                      ' სერვისით სარგებლობის შემთხვევაში, SMS შეტყობინების სახით მიიღებთ ინფორმაციას ტრანზაქციების, პრიზების ჩარიცხვის,საიტზე თქვენი აქტივობის და სხვა სიახლეების შესახებ.'
                    )}
                  </span>
                </p>
              </div>
              <div
                style={{
                  maxWidth: '50px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <Form.Check
                  checked={enableSmsNotify === 'on'}
                  onChange={smsNotifyChange}
                  className={`custom-form-switch ${
                    enableSmsNotify === 'on' ? 'active' : ''
                  }`}
                  size={'4x'}
                  type='switch'
                  id='custom-switch'
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
TabBar.defaultProps = {
  onSelectIndex: (e) => console.log(e),
};
export default TabBar;
